import { theme } from 'antd'

import { AntdConfig } from '@/Ship/Configs/AntdConfig'

/**
 * Палітра кнопок «Колір тексту» і «Маркер» редактора листів (Q13.5, рішення
 * замовника 2026-10-14).
 *
 * Кольори — з теми застосунку: фірмовий і пресетні кольори antd, пораховані
 * статично з `AntdConfig` (як календар дат у ядрі). У тексті листа вони
 * зберігаються **значенням**, а не змінною: лист читають у поштовому клієнті,
 * де змінних теми немає, і колір не має перемикатися разом із темою.
 *
 * Формат — `#rrggbb`: бек пропускає в `style` лише безпечний колір
 * (`RichTextStyleAttributeSanitizer`), і будь-що інше мовчки зникло б після
 * збереження.
 */
export interface RichTextSwatch {
    color: string
    title: string
}

interface PaletteTokens {
    colorPrimary?: string
    [key: string]: unknown
}

const tokens = ((): PaletteTokens => {
    try {
        return theme.getDesignToken(AntdConfig.theme) as unknown as PaletteTokens
    } catch {
        return {}
    }
})()

const pick = (key: string, fallback: string): string => {
    const value = tokens[key]

    return typeof value === 'string' && /^#[0-9a-f]{6}$/i.test(value) ? value.toLowerCase() : fallback
}

/** Колір тексту: насичені відтінки, читаються на білому тлі листа. */
export const TEXT_COLORS: readonly RichTextSwatch[] = [
    { color: pick('colorPrimary', '#ed7768'), title: 'Фірмовий' },
    { color: pick('red7', '#cf1322'), title: 'Червоний' },
    { color: pick('orange7', '#d46b08'), title: 'Помаранчевий' },
    { color: pick('green7', '#389e0d'), title: 'Зелений' },
    { color: pick('blue6', '#1677ff'), title: 'Синій' },
    { color: pick('purple6', '#722ed1'), title: 'Фіолетовий' },
]

/** Маркер: світлі відтінки, під якими текст лишається читабельним. */
export const HIGHLIGHT_COLORS: readonly RichTextSwatch[] = [
    { color: pick('yellow3', '#fffb8f'), title: 'Жовтий' },
    { color: pick('green2', '#d9f7be'), title: 'Зелений' },
    { color: pick('blue2', '#bae0ff'), title: 'Блакитний' },
    { color: pick('red2', '#ffccc7'), title: 'Рожевий' },
    { color: pick('purple2', '#efdbff'), title: 'Бузковий' },
]
